<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Search and Regsisters
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="privacy"
              :label="this.localForm.privacy"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="manage_search"
              hint="search privacy"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="data"
              :label="this.localForm.data"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="lock"
              hint="overwrite"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="register"
              :label="this.localForm.register"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="reorder"
              hint="register"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="search"
              :label="this.localForm.search"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="search"
              hint="search"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4">
            Settings
          </div>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="access"
              :label="this.localForm.access"
              :items="companyAuthLevelDataLimit"
              color="wplblue0"
              prepend-icon="key"
              hint="access restrictions"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="trans"
              :label="this.localForm.trans"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="low_priority"
              hint="approvals"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="asset"
              :label="this.localForm.asset"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="emoji_transportation"
              hint="assets register"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="reg"
              :label="this.localForm.reg"
              :items="companyAuthLevelDataLimit"
              color="wplblue0"
              prepend-icon="format_list_bulleted"
              hint="relationship register"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="risk"
              :label="this.localForm.risk"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="warning"
              hint="risk ranking"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="pri"
              :label="this.localForm.pri"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="info_outline"
              hint="priority range"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap class="ml-2 mr-2">
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="carbu"
              :label="this.localForm.carbu"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="co2"
              hint="carbon units"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md8 lg6>
            <v-select
              :change="updateFormPref()"
              v-model="costu"
              :label="this.localForm.costu"
              :items="companySearchPrivacy"
              color="wplblue0"
              prepend-icon="paid"
              hint="currency"
              persistent-hint
              readonly
            >
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import selectCompany from "@/data/options/mixins/selectCompany.js";
import { mapGetters } from "vuex";
// import TransitionsStage from "@/support/transitions/components/TransitionsStage";
export default {
  // eslint-disable-next-line
  mixins: [
    docRevsModFunctions,
    apptheme,
    selectCompany
  ],
  data() {
    return {
      valid: true,
      localForm: {
        privacy: "",
        access: "",
        costu: "",
        carbu: "",
        data: "",
        register: "",
        reg: "",
        trans: "",
        search: "",
        asset: "",
        risk: "",
        pri: ""
      },
      orgForm: {
        privacy: "",
        costu: "",
        carbu: "",
        access: "",
        data: "",
        register: "",
        reg: "",
        trans: "",
        search: "",
        asset: "",
        risk: "",
        pri: ""
      },
      asset: "",
      data: "",
      reg: "",
      trans: "",
      register: "",
      search: "",
      privacy: "",
      costu: "",
      carbu: "",
      access: "",
      risk: "",
      pri: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    privacy() {
      this.localForm.privacy = this.privacy;
      this.updateFormPref();
    },
    access() {
      this.localForm.access = this.access;
      this.updateFormPref();
    }
  },
  beforeMount() {
    // fix orginal data before change
    this.localForm.privacy = this.getDetailPref.search.privacy;
    this.localForm.costu = this.getDetailPref.settings.costu;
    this.localForm.carbu = this.getDetailPref.settings.carbu;
    this.localForm.asset = this.getDetailPref.settings.asset;
    this.localForm.risk = this.getDetailPref.settings.risk;
    this.localForm.pri = this.getDetailPref.settings.pri;
    this.localForm.access = this.getDetailPref.settings.access;
    this.localForm.data = this.getDetailPref.settings.data;
    this.localForm.reg = this.getDetailPref.settings.reg;
    this.localForm.trans = this.getDetailPref.settings.trans;
    this.localForm.register = this.getDetailPref.search.register;
    this.localForm.search = this.getDetailPref.search.search;

    this.orgForm.privacy = this.getDetailPref.search.privacy;
    this.orgForm.costu = this.getDetailPref.settings.costu;
    this.orgForm.carbu = this.getDetailPref.settings.carbu;
    this.orgForm.access = this.getDetailPref.settings.access;
    this.orgForm.data = this.getDetailPref.settings.data;
    this.orgForm.reg = this.getDetailPref.settings.reg;
    this.orgForm.trans = this.getDetailPref.settings.trans;
    this.orgForm.asset = this.getDetailPref.settings.asset;
    this.orgForm.risk = this.getDetailPref.settings.risk;
    this.orgForm.pri = this.getDetailPref.settings.pri;
    this.orgForm.register = this.getDetailPref.search.register;
    this.orgForm.search = this.getDetailPref.search.search;
  },
  computed: {
    ...mapGetters(["getDetailPref"])
  },
  methods: {
    updateFormPref() {
      let pref = this.getDetailPref;
      // eslint-disable-next-line
      if (this.localForm.privacy !== this.orgForm.privacy) {
        // after the change re-assign new Local to Org
        this.orgForm.privacy = this.localForm.privacy;
        // basic
        pref.search.privacy = this.localForm.privacy;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.51, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
      if (this.localForm.access !== this.orgForm.access) {
        // after the change re-assign new Local to Org
        this.orgForm.access = this.localForm.access;
        // basic
        pref.settings.access = this.localForm.access;
        this.$store.dispatch("changeDetailPref", pref);
        this.saveDocumentRevMod(5.51, 1); // business mod.
        this.$store.dispatch("changeDataSavePendingIndication", true);
      }
    }
  }
};
</script>
